"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _eos = _interopRequireDefault(require("../../clients/eos"));
var _index = require("../../clients/eos/index.enum");
var _useAnalyticsReporting = require("../../utils/hooks/useAnalyticsReporting");
var _index2 = require("../o-auth/index.enum");
const useVehicleHealthService = function () {
  const eosClient = (0, _eos.default)();

  // TODO: Return response validation into this method once the differences between
  // the api-context and internal service layer are reconciled.
  const findSafetyCampaigns = (0, _useAnalyticsReporting.useAnalyticsReporting)(function (vin) {
    return eosClient.post("/v2/vehicle/safety-campaigns", {
      vin
    }, {
      includeReCaptcha: true,
      OAuth: {
        enabled: true,
        resource: _index2.OAuthResource.safetyCampaign
      },
      service: _index.EOSEndpoint.vehicleInfo
    });
  }, {
    name: "findSafetyCampaigns"
  });

  // TODO: Return response validation into this method once the differences between
  // the api-context and internal service layer are reconciled.
  const findVehicleHealthReport = (0, _useAnalyticsReporting.useAnalyticsReporting)(function (vin) {
    return eosClient.get(`/v1/vehicle/${vin}/vehicle-health-report`, {
      includeAuth: true,
      service: _index.EOSEndpoint.vehicleHealth
    });
  }, {
    name: "findVehicleHealthReport"
  });
  return {
    findSafetyCampaigns,
    findVehicleHealthReport
  };
};
var _default = exports.default = useVehicleHealthService;